import React, { Fragment } from 'react';

import Link from 'app/common/components/Link';
import { isEmail } from 'app/developer-v3/utils/isEmail';

type Props = {
  isStaff: boolean;
  text: string;
};

function AdminCell({ isStaff, text }: Props) {
  if (!isEmail(text)) {
    return <Fragment>{text}</Fragment>;
  }

  if (text.includes('@zapier.com') && !isStaff) {
    // We intentionally hide the email since it's not useful to partners.
    return <Fragment>Zapier Staff</Fragment>;
  }

  return <Link href={`mailto:${text}`}>{text}</Link>;
}

export default AdminCell;
